import { Link } from "react-router-dom";
import styled from "styled-components";
import UseBreakpoints from "../../hooks/ui/UseBreakpoints";

// 업무분야 페이지에서 해당 업무를 지원하는 ASCP 모듈을 소개하는 박스 (HeadedBox와 같은 디자인 언어)
const PlatformLink = ({ system, module, text, points, image, caption, to = "/it/ascp" }) => {
  const breakpoints = UseBreakpoints();
  return (
    <Div breakpoints={breakpoints}>
      <div className="head">
        <div>{system}</div>
        <div>{module}</div>
      </div>
      <div className="body">
        <p>{text}</p>
        {points && (
          <ul>
            {points.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </ul>
        )}
        {image && (
          <figure>
            <img src={image} alt={`${system} ${module} 실제 화면`} />
            <figcaption>{caption || "A1 TCMS 실제 서비스 화면 · 표시된 데이터는 예시입니다."}</figcaption>
          </figure>
        )}
        <Link to={to}>ASCP 플랫폼 자세히 보기 →</Link>
      </div>
    </Div>
  );
};
export default PlatformLink;

const Div = styled.div`
  display: flex;
  flex-direction: ${({ breakpoints }) => (breakpoints.md ? "row" : "column")};
  max-width: 65rem;
  margin: 0 auto;
  border-radius: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors?.line};
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadow.sm};
  overflow: hidden;
  & > .head {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.4em;
    padding: 2rem 1.5rem;
    background: radial-gradient(circle at 20% 0%, rgba(1, 101, 172, 0.55), transparent 60%),
      linear-gradient(160deg, ${({ theme }) => theme.colors?.dark}, ${({ theme }) => theme.colors?.ink});
    min-width: 13rem;
    & > div:first-child {
      font-weight: 800;
      color: white;
      font-size: 1.75rem;
      letter-spacing: 0.04em;
    }
    & > div:last-child {
      font-size: 0.95rem;
      color: ${({ theme }) => theme.colors?.foreground?.highlightinverted};
      text-align: center;
    }
  }
  & > .body {
    flex: 1;
    min-width: 0;
    padding: 1.75rem 2rem;
    & > p {
      margin: 0 0 1rem 0;
      font-size: 1.05rem;
      line-height: 1.8;
      color: ${({ theme }) => theme.colors?.monotone?.dark};
    }
    & > ul {
      margin: 0 0 1.25rem 0;
      padding-left: 1.2em;
      line-height: 1.8;
      color: ${({ theme }) => theme.colors?.monotone?.dark};
    }
    & > figure {
      margin: 0 0 1.25rem 0;
      & > img {
        width: 100%;
        border-radius: 0.75rem;
        border: 1px solid ${({ theme }) => theme.colors?.line};
      }
      & > figcaption {
        font-size: 0.85rem;
        color: ${({ theme }) => theme.colors?.foreground?.dimmed};
        padding-top: 0.5rem;
      }
    }
    & > a {
      display: inline-flex;
      font-weight: 700;
      color: ${({ theme }) => theme.colors?.accent};
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
